import type { Announcement } from '../types';

export const a_2026_06_10: Announcement = {
  id: '2026-06-10-analyse-avancee-dossier',
  date: '2026-06-10',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 10 juin 2026',
  title: 'Hector présente :',
  navLabel: "L'analyse avancée du dossier",
  subtitle: "L'analyse avancée du dossier",
  intro: [
    "L'analyse avancée transforme votre façon d'utiliser Hector. D'un seul clic, Hector déclenche un essaim d'agents qui analysent votre dossier sous tous ses angles et en construisent une base de connaissances ultra détaillée, un socle commun sur lequel s'appuient ensuite l'ensemble de vos assistants.",
  ],
  videoNote:
    "L'analyse avancée prend de quelques minutes à quelques heures selon la taille du dossier (comptez environ une heure pour 100 pièces).",
  videoCaption:
    "Regardez cette vidéo explicative pour savoir comment lancer l'analyse avancée et l'utiliser au quotidien.",
  // Lecture intégrée : la vidéo YouTube joue DANS la modale (façade → iframe
  // youtube-nocookie au clic, sans rien quitter). ID repris de l'article du
  // centre d'aide `advanced-case-analysis`
  // (helpArticles.ts → videoUrl https://youtu.be/6NVgDxAgJS4, durée 2:34).
  video: { provider: 'youtube', id: '6NVgDxAgJS4' },
  footer: {
    text: "La vidéo est aussi disponible dans le centre d'aide.",
    cta: {
      label: "Ouvrir le centre d'aide",
      url: 'https://www.app.hector.legal/aide/advanced-case-analysis',
    },
  },
  sections: [
    {
      label: "Ce que l'analyse vous apporte",
      features: [
        {
          id: 'vue-ensemble',
          title: "Une vue d'ensemble du dossier",
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Des analyses transversales qui relient les pièces entre elles, pour saisir l'ensemble du dossier d'un seul coup d'œil.",
            ],
          },
        },
        {
          id: 'graphe-parties',
          title: 'Un graphe des parties et de leurs relations',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Une cartographie visuelle des parties, de leurs rôles et des liens qui les unissent, avec une analyse dédiée à chacune.",
            ],
          },
        },
        {
          id: 'analyse-faits',
          title: 'Chaque fait analysé, un par un',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Hector décortique les faits du dossier un par un et rattache chacun aux pièces qui le fondent.",
            ],
          },
        },
        {
          id: 'chronologies',
          title: 'Des chronologies personnalisées',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Construisez vos propres frises à partir d'une simple consigne, pour suivre la procédure ou les faits sous l'angle qui vous sert.",
            ],
          },
        },
        {
          id: 'enjeux-points-verifier',
          title: 'Les enjeux et points à vérifier',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Incohérences entre pièces, pièces manquantes, points à clarifier, documents à réclamer au client : Hector vous signale ce qui mérite votre attention sur le dossier.",
            ],
          },
        },
        {
          id: 'assistants-plus-precis',
          title: 'Des assistants plus intelligents sur votre dossier',
          body: {
            kind: 'paragraphs',
            paragraphs: [
              "Forts de cette base de connaissances, vos assistants comprennent mieux les enjeux du dossier et formulent des réponses plus fiables.",
            ],
          },
        },
      ],
    },
  ],
};
